export default __webpack_public_path__ + "MBD_Haftungsausschluss_Stand_11-2025.pdf";